module.exports = __webpack_public_path__ + "img/scad-icons.c2552072.svg";